export * from './related-product-set-category.component'
export * from './related-product-set-category-new.component'
export * from './related-product-set-category-edit.component'
